import { FilterKeyEnum, DrawerFilter } from '@hapvida/hapvida-core-components';

import { PartnerCompaniesContractStatusEnum } from '@constants';

import { mappedPartnerStatus } from './mappedPartnerCompaniesStatus';

export function PartnerCompaniesStatusDrawerFilter() {
  const partnerList = Object.values(PartnerCompaniesContractStatusEnum);
  const partnerCompaniesStatusDrawerFilter =
    partnerList.map(mappedPartnerStatus);

  return (
    <DrawerFilter
      filterKey={FilterKeyEnum.PARTNER_COMPANY_STATUS}
      filters={partnerCompaniesStatusDrawerFilter}
      title="Status do contrato"
      label="status do contrato"
      disabledSelectAll
    />
  );
}
